import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import TitleComponent from "../../../components/widgets/titleComponent";
import { useTranslation } from "react-i18next";
import ButtonComponent from "../../../components/form/buttonComponent";
import { useCallback } from "react";
import Threads from "../../../components/animation/threads/threads";
import './joinUs.css';
import { useNavigate } from "react-router-dom";
import {GetTheme, THEME} from '../../../theme/customThemeProvider';

const JoinUsLayout = () => {
    const theme = useTheme();
    const {themeMode} = GetTheme();

    const {t} = useTranslation();

    const navigate = useNavigate();

    const viewJobOpenings = useCallback(() => {
        navigate('/careers');
    }, []);

    return (
        <>
            <Box 
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default,
                    position: 'relative',
                    pb: {xs: 5, md: 20}
                }}
            >
                <div 
                    style={{ 
                        width: '100%', 
                        height: '100%', 
                        position: 'absolute'
                    }}
                >
                    <Threads
                        color={themeMode === THEME.DARK ? [0, 0, 0] : [3, 3, 3]}
                        amplitude={-2}
                        distance={-0.5}
                        enableMouseInteraction={true}
                    />
                </div>

                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    px='5%'
                    pb={2}
                >
                    <TitleComponent 
                        title={t('about.join.title')}
                        description={t('about.join.description')}
                        centerMode
                    />

                    <ButtonComponent 
                        label={t(`about.join.action`)}
                        onClick={viewJobOpenings}
                        sx={{
                            animation: 'bounceButton 1s infinite'
                        }}
                    />
                </Stack>
            </Box>
        </>
    );
}

export default JoinUsLayout;